import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import AlertModal from '../CommonControlls/AlertModal';
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom';
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => { dispatch({ type: "UpdateAlert", payload: Settings }) },
        ShowLoader: (Isloading) => { dispatch({ type: "UpdateLoader", payload: Isloading }) },
    }
}

class DistrictWiseTarget_List extends Component {

    constructor(props) {
        super(props);
        this.state = {

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,

            exportLoading: false,
            Districtlist: [],
            DistrictLoader: false
        };
    }

    render() {

        const CellMenu = (cell, row) => {
            return (
                <div >
                    <Link to={"/DistrictWiseTarget_Edit/" + row.id}><button data-toggle="tooltip" title="Edit" class="btn TableRow_btn"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></button></Link>
                    <button data-toggle="tooltip" title="Delete" onClick={() => this.onDelete(row.id)} class="btn TableRow_btn"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                    <Link to={"/DistrictWiseTarget_Stats/" + row.id}><button title="View" className="btn TableRow_btn"><i
                               className="fa fa-eye " aria-hidden="true"></i></button></Link>
                </div>
            )
        }

        const columns = [
            {
                dataField: 'id',
                text: 'ID',
                sort: true,
            },
            {
                dataField: 'districtName',
                text: 'District',
                sort: true,
            },
            {
                dataField: 'target',
                text: 'Rides Target',
                sort: true,
            },{
                dataField: 'short_name',
                text: 'SR Name',
                sort: true,
            },
            {
                dataField: 'srwiseCount',
                text: 'SR Wise Count',
                sort: true,
            },{
                dataField: 'districtwiseCount',
                text: 'District Wise Count',
                sort: true,
            },
            {
                dataField: 'status',
                text: 'Status',
                sort: true,
            },
            {
                dataField: '',
                text: 'Actions',
                headerStyle: (colum, colIndex) => { return { width: '140px' } },
                formatter: (cell, row) => { return CellMenu(cell, row) },
                csvExport: false
            }
        ];

        return (

            <div>
                <MainLayout />
                <AlertModal  {...this.state.alertModalData} />
                <div id="right-panel" class="right-panel">
                    {/* <Topmenu/>               */}
                    <Topmenu PageTitle="District Wise Targets" isShowAddBtn={true} AddBtnLabel="Add Target" AddBtnLink="/DistrictWiseTarget_Add" />

                    <div class="content">

                        <div class="PageHeader_Container">
                            <h2 class="Pageheading">Targets</h2>
                        </div>

                        <div class="card">
                            <div class="card-body">

                                {/* <div class="TableTop_Buttons">
                        <span class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    exportPdf={this.ExportPdf}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.setState({
                                                exportLoading: true
                                            })
                                            this.ExportData(size)
                                        }, 100)
                                    }}
                                    isPagination={true}
                                    columns={columns}
                                    loading={this.state.loading}
                                    exportAllowed={true}
                                    RefreshTable={this.PopulateTable}
                                />

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }
    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_DistrictWiseTarget", false,"MenuParentLink_Security")

        setTimeout(() => {
            this.PopulateTable()
        }, 1000)
        this.SelectDistricts()
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "sort") {
            let result = this.state.data
            // Handle column sort
            if (sortOrder === 'asc') {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return 1;
                    } else if (b[sortField] > a[sortField]) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return -1;
                    } else if (b[sortField] > a[sortField]) {
                        return 1;
                    }
                    return 0;
                });
            }
            return
        }
        this.setState({
            page,
            sizePerPage
        }, () => { this.PopulateTable() })

    }

    SelectDistricts = () => {
        this.setState({ DistrictLoader: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_District, {}, (data) => {
            this.setState({
                DistrictLoader: false,
                Districtlist: data.data
            })
        }, (error) => {
            this.setState({ DistrictLoader: false })
            this.props.ShowAlert({ Type: 0, Msg: error })
            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
        })
    }

    ExportPdf = () => {
        const doc = new jsPDF()

        this.setState({ loading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Settings/SelectDistrictWiseTargets" ,{}, (resp) => {
                this.setState({ loading: false })
                if (resp.status) {
                    var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                    for (var i in resp.data)
                    {
                        resp.data[i].districtName = ProcessedDistrict[resp.data[i].district_id]?.name
                    }

                    doc.autoTable({
                        theme: 'grid',
                        body: [
                            ...resp.data
                        ],
                        columns: [
                            {header: 'id', dataKey: 'id'},
                            {header: 'SR Name', dataKey: 'short_name'},
                            {header: 'Target', dataKey: 'target'},
                            {header: 'Status', dataKey: 'status'},
                            {header: 'District', dataKey: 'districtName'},
                            {header: 'District Count', dataKey: 'districtwiseCount'},
                            {header: 'SR Count', dataKey: 'srwiseCount'},
                        ],
                    })

                    doc.save('name.pdf')

                }
            }, (error) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }

    ExportData = (size) => {
        this.setState({ loading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Settings/SelectDistrictWiseTargets" ,{}, (resp) => {
                this.setState({ loading: false })
                if (resp.status) {
                    var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                    for (var i in resp.data)
                    {
                        resp.data[i].districtName = ProcessedDistrict[resp.data[i].district_id]?.name
                    }

                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.data.length,
                        exportLoading: false

                    })
                    $(".react-bs-table-csv-btn").click()
                    this.PopulateTable()
                }
            }, (error) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }

    PopulateTable = () => {
        this.setState({ loading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Settings/SelectDistrictWiseTargets" ,{}, (resp) => {
            this.setState({ loading: false })
            if (resp.status) {
                    var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                    for (var i in resp.data)
                    {
                        resp.data[i].districtName = ProcessedDistrict[resp.data[i].district_id]?.name
                    }
                    console.log(resp)
                this.setState({
                    data: resp.data,
                    TotalRecord: resp.data.length
                })
            }
            }, (error) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }

    onDelete = (id) => {
        this.setState({
            alertModalData: {
                title: "Delete Role",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => { $("#Generic-modal-CloseBtn").click(); this.DeleteRecord(id) },
                Second_Callback: () => { $("#Generic-modal-CloseBtn").click() },
                type: 1,
            }
        }, () => { $("#Show_ArletModal").click() })
    }

    DeleteRecord = (id) => {
        this.props.ShowLoader({ Isloading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "POST", false, Common.BaseUrlAPI+`/api/settings/DeleteDistrictWiseTargets?id=${id}`, {},
            (Result) => {
                this.props.ShowLoader({ Isloading: false })
                if (Result.status) {
                    this.PopulateTable()
                    this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully" })
                    setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                }
                else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DistrictWiseTarget_List);
